module.exports = __webpack_public_path__ + "static/media/icon-feliz.e8edf14b.svg";